import styled from '@emotion/styled';
import { IonMenu } from '@ionic/react';

const StyledIonMenu = styled(IonMenu)`
  padding-top: var(--ion-safe-area-top);
  padding-bottom: var(--ion-safe-area-bottom);
`;

export default {
  IonMenu: StyledIonMenu,
};
